import HelpFAQ from './containers/HelpFAQView';
import React from 'react';

export {serverDataHelpFAQSections,serverDataHelpFAQQuestions} from './reducers/HelpFAQView';
export default HelpFAQ;
